import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';

import { ReportDataSourceTable } from 'modules/reportDataSourceTable';
// import type { ReportsTableObject } from 'modules/reportsTable';
// import type { Report } from '../types';

// type Props = {
//   report: Report,
//   clearDataSourceIdsInModal: () => *,
//   closeReportModal: () => *,
//   closeAndSaveModalIds: () => *,
//   reportingTypeTable: ReportsTableObject,
//   isReportModalOpen: boolean,
//   openReportModal: (string, Object) => *,
// };

const ReportModalWrapper = (state, props) => ({
  report: state.reports[props.match.params.id],
});

export class ReportModal extends React.Component {
  componentDidMount() {
    this.props.clearDataSourceIdsInModal();
  }

  get selectButtonText() {
    return this.props.report.componentIds.length > 0 ? 'Update Selected' : 'Select';
  }

  renderModalButton = () => {
    const { report, reportingTypeTable, openReportModal } = this.props;
    const { selectedTypeIds } = reportingTypeTable || {};
    const { componentType } = report;

    let buttonText;

    if (selectedTypeIds[componentType]) {
      const count = selectedTypeIds[componentType].length;
      if (count > 0) {
        buttonText = `${count} ${componentType}${count !== 1 ? 's' : ''} Selected`;
      } else {
        buttonText = `Show ${componentType}s`;
      }
    }

    return (
      <Button
        onClick={() => openReportModal(componentType, reportingTypeTable)}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        {buttonText}
      </Button>
    );
  };

  render() {
    const {
      report,
      isReportModalOpen,
      closeReportModal,
      reportingTypeTable,
      closeAndSaveModalIds,
    } = this.props;

    if (!report) {
      return null;
    }

    return (
      <div data-test="report-modal-container">
        {this.renderModalButton()}
        {/* <Transition visible={isReportModalOpen}> */}
        {isReportModalOpen ? (
          <Modal
            isModalOpen={isReportModalOpen}
            onClose={closeReportModal}
            size={MODAL_SIZES.LARGE}
          >
            <ModalHeader>Select {report.componentType} for this report</ModalHeader>
            <ModalBody>
              <ReportDataSourceTable />
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() =>
                  closeAndSaveModalIds(
                    reportingTypeTable.selectedTypeIdsInModal,
                    report.id,
                    report.componentType,
                  )
                }
              >
                {this.selectButtonText}
              </Button>
            </ModalFooter>
          </Modal>
        ) : null}
        {/* </Transition> */}
      </div>
    );
  }
}

export default withRouter(connect(ReportModalWrapper)(ReportModal));
